// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__monoFont_fd57dd', '__monoFont_Fallback_fd57dd', Nitti, Menlo, Courier, monospace"},"className":"__className_fd57dd","variable":"__variable_fd57dd"};